export default __webpack_public_path__ + "static/media/kids-Room_D112-A13-SP.STROP.bd736aad.jpg";